import StarRating from '../shared/StarRating'
import { getImageUrl, IMAGE_CONFIG } from '../../config/settings'

interface RoomImageGalleryProps {
  images: Array<{ url: string }>
  featuredImg: string
  title: string
  selectedImage: number
  rating: number
  categoryName?: string
  rent: number
  onImageSelect: (index: number) => void
}

const RoomImageGallery = ({
  images,
  featuredImg,
  title,
  selectedImage,
  rating,
  categoryName,
  rent,
  onImageSelect
}: RoomImageGalleryProps) => {
  // Build images array: use images if available, otherwise use featuredImg
  const allImages = images && images.length > 0 
    ? images 
    : (featuredImg ? [{ url: featuredImg, id: 0, created_at: null, is_featured: true }] : [])
  
  // Get current image URL
  const currentImageUrl = allImages[selectedImage]?.url || featuredImg || ''
  
  return (
    <div className="space-y-3 sm:space-y-4">
      {/* Main Image */}
      <div className="room-image-gallery relative group">
        <img
          src={getImageUrl(currentImageUrl)}
          alt={title}
          className="w-full aspect-[4/3] lg:aspect-[5/4] object-cover rounded-xl sm:rounded-2xl shadow-2xl transition-transform duration-500 group-hover:scale-105"
          onError={(e) => {
            e.currentTarget.src = IMAGE_CONFIG.FALLBACK_IMAGE
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent rounded-xl sm:rounded-2xl"></div>
        <div className="price-overlay absolute top-3 right-3 sm:top-4 sm:right-4 text-white px-3 py-1.5 sm:px-4 sm:py-2 rounded-lg sm:rounded-xl font-bold text-sm sm:text-lg shadow-lg">
          ₹{rent} / Night
        </div>
        <div className="absolute bottom-3 left-3 sm:bottom-4 sm:left-4 text-white">
          <div className="mb-1 sm:mb-2">
            <StarRating rating={rating} size="sm" showValue className="[&_span:last-child]:text-white/90" />
          </div>
          <p className="text-xs sm:text-sm text-white/90">{categoryName || 'Room'}</p>
        </div>
      </div>

      {/* Thumbnail Images */}
      {allImages.length > 1 && (
        <div className="flex gap-2 sm:gap-4 overflow-x-auto pb-2 scrollbar-hide">
          {allImages.map((image, index) => (
            <button
              key={image.id || index}
              onClick={() => onImageSelect(index)}
              className={`thumbnail-image flex-shrink-0 w-14 h-14 sm:w-20 sm:h-20 rounded-lg sm:rounded-xl overflow-hidden transition-all duration-300 ${
                selectedImage === index 
                  ? 'ring-2 ring-primary-500 scale-110 shadow-lg' 
                  : 'hover:scale-105'
              }`}
            >
              <img
                src={getImageUrl(image.url)}
                alt={`Room view ${index + 1}`}
                className="w-full h-full object-cover"
                onError={(e) => {
                  e.currentTarget.src = IMAGE_CONFIG.THUMBNAIL_FALLBACK
                }}
              />
            </button>
          ))}
        </div>
      )}
    </div>
  )
}

export default RoomImageGallery

